import React, { Component } from "react";
import { ChatEngine } from 'react-chat-engine';
import ChatFeed from './ChatFeed';
//import LoginForm from './LoginForm';
import './chat.css';
import axios from 'axios';

const Chat= () => {
  
  let userData = JSON.parse(localStorage.getItem("currentUser"));
  const projectID = "3de9d5b1-3a5a-4b30-9098-4103abfe23da";
  const userName = userData.userName;
  const password  = "123456";
  
  const fetchData = async () => {
    
      const authObject = {'Project-ID': {projectID}, 
          'User-Name': {userName}, 
          'User-Secret': {password} 
        };
      try {
           await axios.get('https://api.chatengine.io/chats', { headers: authObject });
      }catch (err) {
      console.log('Oops, incorrect credentials.');
      }
  };

  fetchData();
  
    return(
      <div className="mentoring-chat">
          <ChatEngine
            height="100vh"
            projectID={projectID}
            userName={userName} 
            userSecret={password}
            renderChatFeed={(chatAppProps) => <ChatFeed {...chatAppProps} />}
            onNewMessage={() => new Audio('https://chat-engine-assets.s3.amazonaws.com/click.mp3').play()}
          />
      </div>
    )
}
export default Chat;
